// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  pointer-events: none;
}

.splash-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #093656;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: all 1.2s cubic-bezier(0.4, 0, 0, 1);
  will-change: opacity, transform;
  transform-origin: center center;
  transform: scale(1.2);
}
@supports (-webkit-touch-callout: none) {
  .splash-overlay {
    height: -webkit-fill-available;
  }
}
.splash-overlay.fade-out {
  opacity: 0;
  pointer-events: none;
  transform: scale(1.4);
  filter: brightness(1.2) blur(8px);
  transition: all 1.2s cubic-bezier(0.4, 0, 0, 1);
}
.splash-overlay img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  will-change: transform, opacity;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0) scale(1);
  -webkit-transform: translateZ(0) scale(1);
  transition: transform 1.2s cubic-bezier(0.4, 0, 0, 1);
  opacity: 1;
}

:host-context(.content-visible) {
  animation: revealContent 1.2s cubic-bezier(0.4, 0, 0, 1);
}

@keyframes revealContent {
  0% {
    opacity: 0;
    transform: scale(0.95);
    filter: brightness(1.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: brightness(1);
  }
}
.no-animation {
  animation: none !important;
  transition: none !important;
}

@keyframes fadeBackground {
  0% {
    background-color: #093656;
    opacity: 1;
  }
  100% {
    background-color: transparent;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/splash-overlay/splash-overlay.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,+CAAA;EACA,+BAAA;EACA,+BAAA;EACA,qBAAA;AACF;AACE;EAnBF;IAoBI,8BAAA;EAEF;AACF;AAAE;EACE,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,iCAAA;EACA,+CAAA;AAEJ;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,2BAAA;EACA,mCAAA;EACA,iCAAA;EACA,yCAAA;EACA,qDAAA;EACA,UAAA;AACJ;;AAIA;EACE,wDAAA;AADF;;AAIA;EACE;IACE,UAAA;IACA,sBAAA;IACA,uBAAA;EADF;EAGA;IACE,UAAA;IACA,mBAAA;IACA,qBAAA;EADF;AACF;AAKA;EACE,0BAAA;EACA,2BAAA;AAHF;;AAOA;EACE;IACE,yBAAA;IACA,UAAA;EAJF;EAMA;IACE,6BAAA;IACA,UAAA;EAJF;AACF","sourcesContent":[":host {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n  pointer-events: none;\n}\n\n.splash-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #093656;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 1;\n  transition: all 1.2s cubic-bezier(0.4, 0, 0, 1);\n  will-change: opacity, transform;\n  transform-origin: center center;\n  transform: scale(1.2);\n  \n  @supports (-webkit-touch-callout: none) {\n    height: -webkit-fill-available;\n  }\n  \n  &.fade-out {\n    opacity: 0;\n    pointer-events: none;\n    transform: scale(1.4);\n    filter: brightness(1.2) blur(8px);\n    transition: all 1.2s cubic-bezier(0.4, 0, 0, 1);\n  }\n  \n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    will-change: transform, opacity;\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n    transform: translateZ(0) scale(1);\n    -webkit-transform: translateZ(0) scale(1);\n    transition: transform 1.2s cubic-bezier(0.4, 0, 0, 1);\n    opacity: 1;\n  }\n}\n\n// Reveal content with a nice fade-in\n:host-context(.content-visible) {\n  animation: revealContent 1.2s cubic-bezier(0.4, 0, 0, 1);\n}\n\n@keyframes revealContent {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n    filter: brightness(1.5);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n    filter: brightness(1);\n  }\n}\n\n// Prevent animation on page load\n.no-animation {\n  animation: none !important;\n  transition: none !important;\n}\n\n// Background transition\n@keyframes fadeBackground {\n  0% {\n    background-color: #093656;\n    opacity: 1;\n  }\n  100% {\n    background-color: transparent;\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
